export default __webpack_public_path__ + "static/media/new-image-disabled.3b2a9e48.svg";